import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { bsc, bscTestnet } from 'wagmi/chains';
import type { Chain } from 'viem';
import {
  metaMaskWallet,
  trustWallet,
  coinbaseWallet,
  walletConnectWallet,
  injectedWallet,
  safeWallet,
  rainbowWallet,
} from '@rainbow-me/rainbowkit/wallets';

// WalletConnect Project ID - Get from https://cloud.walletconnect.com
// Using a proper fallback to avoid WebSocket errors
const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || '2f5a2c1b8e3d4f6a7b8c9d0e1f2a3b4c';

// Get network configuration from environment (default to mainnet)
const isTestnet = import.meta.env.VITE_NETWORK === 'testnet';

// Configure chains based on environment (prioritize mainnet)
const chains: readonly [Chain, ...Chain[]] = isTestnet ? [bscTestnet, bsc] : [bsc, bscTestnet];

// Mobile-optimized wallet configuration
const wallets = [
  {
    groupName: 'Popular',
    wallets: [
      metaMaskWallet,
      trustWallet,
      coinbaseWallet,
      walletConnectWallet,
    ],
  },
  {
    groupName: 'More Options',
    wallets: [
      injectedWallet,
      safeWallet,
      rainbowWallet,
    ],
  },
];

export const config = getDefaultConfig({
  appName: 'VOICE Pay - AI Payment Assistant',
  projectId,
  chains,
  wallets,
  ssr: false,
});

export { chains };

// Mobile detection utility
export const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    window.navigator.userAgent
  );
};

// Deep link utilities for mobile wallets
export const getMobileWalletDeepLink = (walletName: string, uri: string) => {
  const encodedUri = encodeURIComponent(uri);
  
  switch (walletName.toLowerCase()) {
    case 'metamask':
      return `https://metamask.app.link/wc?uri=${encodedUri}`;
    case 'trust':
    case 'trustwallet':
      return `https://link.trustwallet.com/wc?uri=${encodedUri}`;
    case 'coinbase':
      return `https://go.cb-w.com/wc?uri=${encodedUri}`;
    case 'rainbow':
      return `https://rnbwapp.com/wc?uri=${encodedUri}`;
    default:
      return uri;
  }
};